let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("u2Avf"), load("4CFMq")]).then(() => parcelRequire('92KZy'));